import script from "./ComSuunnittelutiedotRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComSuunnittelutiedotRow.vue?vue&type=script&setup=true&lang=ts"

import "./ComSuunnittelutiedotRow.vue?vue&type=style&index=0&id=369043c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369043c1"]])

export default __exports__